import React, { useCallback } from "react";
import { useDispatch } from 'react-redux';
import moment from "moment";
import { Col, DatePicker, Form, Input, Modal, Row } from "antd";
import { EditDocumentIcon } from "../../../resource/icons";

import actions from '../store/actions/edit-document.actions';

const EditNumberDateModal = ({
  onCancel,
  visible,
  fprops,
  getFieldDecorator,
  validateFields,
  prepareDataAndResetFields,
}) => {
  const dispatch = useDispatch();

  const onOk = useCallback(() => {
    validateFields((err, values) => {
      if (err) return;
      const v = prepareDataAndResetFields(values);
      if (v.DocNumber !== fprops.docNumber) {
        dispatch(actions.updateDocNumber(v.id, v.DocNumber));
      }
      if (v.DocMoment && v.DocMoment.toISOString() !== fprops.docDate) {
        dispatch(
          actions.updateDocRegDate(v.id, v.DocMoment.format('YYYY-MM-DD'))
        );
      }
      dispatch(actions.closeModal());
    });
  }, [
    dispatch,
    fprops.docDate,
    fprops.docNumber,
    prepareDataAndResetFields,
    validateFields,
  ]);

	return (
		<Modal
			style={{ minWidth: 350 }}
			width={350}
			visible={visible}
			title={
				<span>
					<EditDocumentIcon
						style={{
							height: 40,
							verticalAlign: "middle",
							marginRight: 10,
						}}
					/>{" "}
					Номер и дата документа
				</span>
			}
			okText="Изменить"
			onCancel={onCancel}
			onOk={onOk}
		>
			<Form layout="vertical">
				{getFieldDecorator("OrgId", {
					initialValue: fprops.org && fprops.org.id,
				})(<div />)}
				{getFieldDecorator("executerId", {
					initialValue: fprops.appointedWorker && fprops.appointedWorker.id,
				})(<div />)}
				{getFieldDecorator("Topic", { initialValue: fprops.topic })(<div />)}
        <Row  gutter={8}>
					<Col span={12}>
						<Form.Item label="Номер">
							{getFieldDecorator("DocNumber", {
								initialValue: fprops.docNumber,
								rules: [
									{
										required: true,
										message: "Пожалуйста, укажите номер документа",
									},
								],
							})(<Input />)}
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Дата регистрации">
							{getFieldDecorator("DocMoment", {
								initialValue: fprops.docDate
									? moment(fprops.docDate)
									: moment(),
								rules: [
									{
										required: true,
										message: "Пожалуйста, укажите дату документа",
									},
								],
							})(
								<DatePicker
									style={{ width: 125 }}
									allowClear={false}
									format="DD.MM.YYYY"
								/>
							)}
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default EditNumberDateModal;
